import React, { useContext, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Avatar from 'antd/es/avatar/avatar';
import Paper from '@mui/material/Paper';
import {
  Typography,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Stack,
  Box,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { poppins500, poppins400 } from 'theme/common.style';
import {
  DownArrow,
  GreyPaper,
  ColorPaper,
} from 'component/BuyersMarketplace/Marketplaceicons';
import PropTypes from 'prop-types';
import { propertyDetail } from 'component/Chart/ModelGraphExpand.style';
import { getApiCall } from 'api/apiService';
import { DEPOSIT_MANAGER_DETAILS, GET_BINDERID } from 'constant/app.config';
import { Contact } from 'component/BuyerRegistration/BuyerRegistration.util';
import Moxochat from 'component/Moxochat/Moxochat';
import { useHistory } from 'react-router-dom';
import { datacontext } from 'modules/AppLayout/AppLayout';
import Loading from 'assets/images/loading.png';
export const CircularProgressWithProfile = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={props.value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {props.profileImage == '' || props.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                backgroundColor: '#666666',
              }}
            >
              {props.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props.name}
              src={props.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};

function SelectBuyerTable(props) {
  const {
    openBuyerListPopup,
    setOpenBuyerListPopup,
    profileDetails,
    setSelectedBuyerData,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));

  function createData(id, name, calories, fat, carbs, protein) {
    return {
      id,
      name,
      calories,
      fat,
      carbs,
      protein,
    };
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const headCells = [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
    },
    {
      id: 'calories',
      numeric: true,
      disablePadding: false,
      label: 'Contact',
    },
    {
      id: 'fat',
      numeric: true,
      disablePadding: false,
      label: 'Status',
    },
    {
      id: 'carbs',
      numeric: true,
      disablePadding: false,
      label: 'Offers',
    },
    {
      id: 'protein',
      numeric: true,
      disablePadding: false,
      label: 'Number of Offers',
    },
  ];

  function EnhancedTableHead(props) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell
            padding="checkbox"
            sx={{ padding: '12px', borderBottom: 'none' }}
          >
            <input
              type="checkbox"
              disabled
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all desserts',
              }}
              style={{
                accentColor: '#A55FFB',
                cursor: 'no-drop',
                width: '16px',
                height: '16px',
              }}
            />
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'center'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{
                fontSize: '10px',
                fontWeight: '400',
                fontFamily: 'Poppins',
                color: '#666666',
                textAlign: 'center',
                borderBottom: 'none',
                whiteSpace: 'nowrap',
                '@media (max-width:600px)': {
                  fontSize: '8px',
                },
              }}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');

  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = profileDetails?.BuyerRegisterDetails.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const [selectedBuyerId, setSelectedBuyerId] = useState();
  const [selectedBuyerName, setSelectedBuyerName] = useState();
  const [depositDetailsLoader, setDepositDetailsLoader] = useState(false);
  const [selected, setSelected] = useState([]);

  const propertyId = profileDetails?.PropertyDetails?.property?.propertyId;

  const input = {
    propertyId: propertyId,
    buyerId: selectedBuyerId,
  };

  const getDetailsData = async () => {
    setDepositDetailsLoader(true);
    try {
      const res = await getApiCall(DEPOSIT_MANAGER_DETAILS, input);

      if (res?.status == 200) {
        setSelectedBuyerData(res?.data);
      }
    } catch (error) {
    } finally {
      setDepositDetailsLoader(false);
      setOpenBuyerListPopup(false);
      setSelected([]);
      setSelectedBuyerName({});
      setSelectedBuyerId({});
    }
  };

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        setOpenBuyerListPopup(false);
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { realTimeLog, setIschatopen } = useContext(datacontext);

  const history = useHistory();

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0
      ? Math.max(
          0,
          (1 + page) * rowsPerPage - profileDetails?.BuyerRegisterDetails.length
        )
      : 0;

  const visibleRows = React.useMemo(
    () =>
      [...profileDetails?.BuyerRegisterDetails]
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage]
  );

  const CircularProgressWithProfileVendor = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={43}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={43}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  width: '36px',
                  height: '36px',
                  fontFamily: 'poppins',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt={props.name}
                src={props.profileImage}
                style={{
                  width: '36px',
                  height: '36px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    if (depositDetailsLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [depositDetailsLoader]);

  return (
    <React.Fragment>
      <Dialog
        open={openBuyerListPopup}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            width: matchessm ? '100vw' : '767px',
            maxWidth: matchessm ? '100vw' : 'unset',
            padding: matchessm ? '20px' : '30px',
            margin: matchessm ? '0' : 'auto',
            overflowX: 'hidden',
          },
        }}
      >
        <Stack direction="column" spacing={1.25} sx={{ px: 2.5 }}>
          <Box>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '16px' : '24px',
                color: '#000000',
              }}
            >
              Select Buyer
            </Typography>
          </Box>

          <Box>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Choose which buyers to request a Deposit Payment from. Only one
              buyer can be selected.
            </Typography>
          </Box>
        </Stack>

        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Table
              sx={{ minWidth: 'auto' }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={propertyDetail?.BuyerRegisterDetails?.length}
              />
              {visibleRows?.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={6}>
                      <Box
                        sx={{
                          height: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 500,
                          color: '#666666',
                        }}
                      >
                        No data found
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {visibleRows?.map((row, index) => {
                    const isItemSelected = selected.includes(
                      row?.buyerDetails?.user?.userId
                    );
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        onClick={(event) => {
                          const userId = row?.buyerDetails?.user?.userId;
                          if (!row?.buyerDetails?.buyerOffer?.offerPrice)
                            return;

                          // If already selected, unselect
                          if (selectedBuyerId === userId) {
                            setSelectedBuyerId(null);
                            setSelectedBuyerName(null);
                          } else {
                            setSelectedBuyerId(userId);
                            setSelectedBuyerName(row?.buyerDetails);
                          }
                        }}
                        role="checkbox"
                        aria-checked={
                          row?.buyerDetails?.user?.userId === selectedBuyerId
                        }
                        tabIndex={-1}
                        key={row?.buyerDetails?.user?.userId}
                        selected={
                          row?.buyerDetails?.user?.userId === selectedBuyerId
                        }
                        sx={{ cursor: 'pointer', height: '85px' }}
                      >
                        <TableCell padding="checkbox" sx={{ padding: '12px' }}>
                          <input
                            type="checkbox"
                            checked={
                              row?.buyerDetails?.user?.userId ===
                              selectedBuyerId
                            }
                            onChange={() => {
                              const userId = row?.buyerDetails?.user?.userId;

                              if (!row?.buyerDetails?.buyerOffer?.offerPrice)
                                return;

                              // If already selected, unselect
                              if (selectedBuyerId === userId) {
                                setSelectedBuyerId(null);
                                setSelectedBuyerName(null);
                              } else {
                                setSelectedBuyerId(userId);
                                setSelectedBuyerName(row?.buyerDetails);
                              }
                            }}
                            inputProps={{
                              'aria-labelledby': labelId,
                            }}
                            style={{
                              accentColor: '#A55FFB',
                              cursor: 'pointer',
                              width: '16px',
                              height: '16px',
                            }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            // borderBottom: "none",
                            padding: '8px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '4px 8px', // inner padding
                              width: '100%',
                              boxSizing: 'border-box',
                              '@media (max-width:600px)': {
                                gap: '4px',
                                padding: '4px 6px',
                              },
                            }}
                          >
                            <CircularProgressWithProfileVendor
                              value={row?.buyerDetails?.profileActivity}
                              profileImage={
                                row?.buyerDetails?.user?.userProfile
                              }
                              name={
                                row?.buyerDetails?.user?.userName
                                  .charAt(0)
                                  ?.toUpperCase() +
                                row?.buyerDetails?.user?.userSurName
                                  .charAt(0)
                                  ?.toUpperCase()
                              }
                            />
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: '400',
                                fontFamily: 'Poppins',
                                color: '#112347',
                                whiteSpace: 'nowrap',
                                '@media (max-width:600px)': {
                                  fontSize: '10px',
                                },
                              }}
                            >
                              {row?.buyerDetails?.user?.userName +
                                ' ' +
                                row?.buyerDetails?.user?.userSurName}
                            </Typography>
                            <DownArrow
                              sx={{
                                fontSize: '18px',
                                '@media (max-width:600px)': {
                                  fontSize: '14px',
                                },
                              }}
                            />
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'center',
                            padding: '8px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <Contact
                            row={row?.buyerDetails}
                            directcomm={directcomm}
                            index={null}
                          />
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'center',
                            padding: '8px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row?.buyerDetails?.is66Signed == 1 ? (
                            <ColorPaper />
                          ) : (
                            <GreyPaper />
                          )}
                        </TableCell>

                        <TableCell sx={{ gap: '5px' }}>
                          <Typography
                            sx={{
                              fontSize: '14px',
                              fontWeight: '400',
                              fontFamily: 'Poppins',
                              color: '#112347',
                              textAlign: 'center',
                              padding: '8px',
                              whiteSpace: 'nowrap',
                              '@media (max-width:600px)': {
                                fontSize: '12px',
                                padding: '4px',
                              },
                            }}
                          >
                            {row?.buyerDetails?.buyerOffer?.offerPrice ?? '-'}
                          </Typography>
                          <br />
                          <Typography
                            sx={{
                              display: !row?.buyerDetails?.buyerOffer
                                ?.offerPrice
                                ? 'none'
                                : 'flex',
                              width: '85px',
                              padding: '3px 6px',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '10px',
                              borderRadius: '5px',
                              background:
                                row?.buyerDetails?.buyerOffer
                                  ?.logIsConditional == 1
                                  ? 'rgba(237, 11, 11, 0.60)'
                                  : '#10D35E',
                              marginTop: '-2px',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#FFF',
                                fontFamily: 'Poppins',
                                fontSize: matches380 ? '8px' : '10px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                              }}
                            >
                              {row?.buyerDetails?.buyerOffer
                                ?.logIsConditional == 1
                                ? 'Conditional'
                                : 'Unconditional'}
                            </Typography>
                          </Typography>
                        </TableCell>

                        <TableCell
                          sx={{
                            fontSize: '14px',
                            fontWeight: '400',
                            fontFamily: 'Poppins',
                            color: '#112347',
                            textAlign: 'center',
                            padding: '8px',
                            whiteSpace: 'nowrap',
                            '@media (max-width:600px)': {
                              fontSize: '12px',
                              padding: '4px',
                            },
                          }}
                        >
                          {row?.buyerDetails?.noOfOffers}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Paper>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          sx={{ mt: 4 }}
        >
          <Button
            variant="outlined"
            disabled={depositDetailsLoader}
            onClick={() => {
              setOpenBuyerListPopup(false);
              setSelectedBuyerName({});
              setSelectedBuyerId({});
            }}
            sx={{
              padding: matchessm ? '6px 23px' : '10px 39px',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '15px',
              color: '#666666',
              fontWeight: '400',
              fontFamily: 'Poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              padding: matchessm ? '6px 30px' : '10px 50px',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '15px',
              color: '#FFFFFF',
              fontWeight: 400,
              fontFamily: 'Poppins',
              backgroundColor: '#4CA4D6',
              textTransform: 'none',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#4CA4D6',
              },
              '&.Mui-disabled': {
                backgroundColor: '#4CA4D6',
                color: '#fff',
                opacity: 0.7,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
              },
            }}
            disabled={
              depositDetailsLoader
                ? depositDetailsLoader
                : !selectedBuyerName?.user && true
            }
            onClick={getDetailsData}
          >
            Confirm
          </Button>
          {depositDetailsLoader && (
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '40px', width: '40px' }}
            />
          )}
        </Stack>
      </Dialog>

      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}

      {/* <Dialog
        open={Confirmdepositrequestopen}
        onClose={() => setConfirmDepositRequest(false)}
        PaperProps={{
          sx: {
            borderRadius: "5px",
            // height: matchessm ? "350px" : "300px",/
            minWidth: matchessm ? "95%" : "400px",
            boxShadow: " -4px, 4px rgba(0, 0, 0, 0.09)",
            padding: matchessm ? "30px 20px" : "30px",
          },
        }}
      >
        <Grid container height={"100%"}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? "10px" : "14px",
                color: "#666666",
              }}
            >
              {"   "}
              ADDRESS &nbsp; &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            alignItems={"center"}
            padding={"20px 0px"}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? "16px" : "24px",
                paddingLeft: "12px",
              }}
            >
              Confirm Deposit Request
            </Typography>
          </Grid>
          <Grid item textAlign={"left"}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? "12px" : "16px",
                color: "#666666",
              }}
            >
              Are you sure you want to send a deposit request to{" "}
              <b>Kiel Glass</b> for
              <b>$235,000.</b>
            </Typography>
          </Grid>

          <Grid item textAlign={"left"} marginTop={3}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? "12px" : "16px",
                color: "#666666",
              }}
            ></Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={"flex-end"}
            gap={2}
            marginTop={matchessm ? 2 : 4}
          >
            <Grid item>
              <Button
                disabled={depositDetailsLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? "6px 23px" : "10px 39px",
                  width: "100%",
                  height: matchessm ? "35px" : "41px",
                  fontSize: matchessm ? "12px" : "14px",
                  color: "#666666",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  border: "1px solid rgba(17, 35, 71, 0.1)",
                  borderRadius: "5px",
                  textTransform: "capitalize",
                }}
                onClick={() => setConfirmDepositRequest(false)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <Button
                disabled={depositDetailsLoader}
                onClick={getDetailsData}
                variant="outlined"
                endIcon={depositDetailsLoader && <CircularProgress />}
                sx={{
                  padding: matchessm ? "6px 23px" : "10px 39px",
                  height: matchessm ? "35px" : "41px",
                  fontSize: matchessm ? "12px" : "14px",
                  color: "#FFFFFF",
                  fontWeight: 400,
                  fontFamily: "Poppins",
                  background: "#4CA4D6",
                  borderRadius: "5px",
                  textTransform: "capitalize",
                  "&:hover": {
                    background: "#4CA4D6",
                    boxShadow: "none", // if you want to prevent elevation/shadow change
                  },
                }}
              >
                Confirm
              </Button>

              {loading && (
                <CircularProgress
                  size={matchessm ? 25 : 32}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#4CA4D6",
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog> */}
    </React.Fragment>
  );
}

export default SelectBuyerTable;
